import { Box, H3 } from '@ouster/webviz-react-components';

import { ReactNode } from 'react';

import userLookupStyle from './userLookup.module.css';

interface DashboardCardProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: ReactNode;
  title: string;
  description?: string;
  children?: ReactNode;
  className?: string;
  headerExtra?: ReactNode;
  style?: React.CSSProperties;
}

export default function DashboardCard({
  icon,
  title,
  description,
  children,
  className,
  headerExtra,
  style,
  ...rest
}: DashboardCardProps) {
  return (
    <Box
      border="1px solid"
      borderColor="whiteAlpha.200"
      borderRadius="md"
      bgColor="whiteAlpha.50"
      display="grid"
      gap={6}
      px={8}
      py={6}
      className={className}
      style={style}
      {...rest}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        gap={6}
      >
        <Box>
          <Box className={userLookupStyle.title}>
            {icon}
            <H3 fontSize={18} data-testid="dashboard-card-title">
              {title}
            </H3>
          </Box>
          {description && (
            <Box
              as="p"
              color="gray.300"
              mt={2}
              lineHeight={1.5}
              data-testid="dashboard-card-description"
            >
              {description}
            </Box>
          )}
        </Box>
        {headerExtra}
      </Box>
      {children}
    </Box>
  );
}
